
<script>
    import { createEventDispatcher } from 'svelte';
    import { onMount } from "svelte";
    import Fa from 'svelte-fa'
    import { faList } from '@fortawesome/free-solid-svg-icons'
    import CheeseSellOff from '../components/CheeseSellOff.svelte'

    let modal;

    //export let customer = '';
    
    const dispatch = createEventDispatcher();
    
    onMount(async function () {});

    function clickExecuted() {
        modal.show();
    }

    /*function accepted() {
        dispatch('sellOffConfirmed', {
            
        });
    }*/
</script>

<div class="IconHistory" on:click={clickExecuted}>
    <Fa icon={faList} on:clicked={clickExecuted}/>
</div>
<div class="TextSellOff" on:click={clickExecuted}>Historie&nbsp;&nbsp;&nbsp;</div>

<!--CheeseSellOff bind:this={modal} customer={customer} on:accepted={accepted}/-->

<style>
    .IconHistory {
        padding-right: 10px;
        cursor: pointer;
        color: rgb(255, 0, 157);
    }
    
    .TextSellOff {
        cursor: pointer;
    }
</style>